import moment from 'moment';
import Card from 'food-benefit.module/common/domain/models/foodBenefitCard';
import {CARD_STATUS, MODAL_STATES} from 'food-benefit.module/common/domain/constants';
import Swipe from 'common/utils/swipe';

class BenefitRequestCardController {
  constructor(EventEmitter, $timeout) {
    'ngInject';
    this.EventEmitter = EventEmitter;
    this.timeout = $timeout;
  }

  $onInit() {
    moment.locale('es');
    let dateToGetMonth = new Date(this.request.enjoymentYear,
      this.request.enjoymentMonth - 1);
    this.displayMonth = moment(dateToGetMonth).format('MMMM');
    this.card = new Card(this.request);
    this.days = this.request.enjoymentDays;
  }

  $postLink() {
    if (this.isMobileApp) {
      this.timeout(() => {
        this.initSwipe();
      });
    }
  }

  getClasses() {
    return {
      responsiveMobile: this.isMobileApp,
      swiped: this.swiped
    };
  }

  initSwipe() {
    const swiper = new Swipe(this.getBenefitRequestCardSelector());
    swiper.onLeft(() => this.onSwipeLeft());
    swiper.onRight(() => this.onSwipeRight());
    swiper.run();
  }

  getBenefitRequestCardSelector() {
    return `benefit-request-card .${this.cardId}`;
  }

  onSwipeRight() {
    this.timeout(() => {
      this.swiped = false;
    });
  }

  onSwipeLeft() {
    this.timeout(() => {
      this.swiped = true;
    });
  }

  setDays({days}) {
    this.dayPeriods = days;
    this.request.enjoymentDays = this.dayPeriods;
  }

  shouldDisplayCard() {
    return this.request.status !== MODAL_STATES.approved || this.request.status !== MODAL_STATES.rejected;
  }

  onAccept() {
    this.request.enjoymentDays = this.dayPeriods;
    this.request.status = CARD_STATUS.APPROVE;

    let event = this.EventEmitter({
      request: this.request,
    });

    this.processRequest(event);
  }

  onReject() {
    this.request.enjoymentDays = this.dayPeriods;
    this.request.status = CARD_STATUS.REJECT;

    let event = this.EventEmitter({
      request: this.request,
    });

    this.processRequest(event);
  }
}

export default BenefitRequestCardController;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/components/benefitRequestList/benefitRequestCard/benefitRequestCard.controller.js